import { useLocaleKeys } from '~/i18n';
import { useIoContext } from '~/providers/IoContext';
export const useBiometricMethodLabel = ()=>{
    const { native } = useIoContext();
    const { t: commonTexts } = useLocaleKeys('common');
    return native.platform === 'ios' ? commonTexts.biometricMethod.faceId() : commonTexts.biometricMethod.fingerprint();
};
